import config from '@config'
import { APICommentingData } from '@widgets/Commenting/types'
import { FunctionComponent, ReactNode, useContext } from 'react'
import { useQuery } from 'react-query'
import GenericCommentingContext from './genericContext'
import TopCommentAPIContext from './topCommentApiContext'

const {
  community: { baseUrl, getUrlPlain },
} = config

const getTopComments = async ({
  articleId,
}: {
  articleId: string
}): Promise<APICommentingData> => {
  const response = await fetch(
    `${baseUrl}${getUrlPlain}/?discussion_type_id=${articleId}&top_rated=true&size=5`
  )

  if (response.status >= 400 && response.status < 600) {
    throw new Error(`Server responded with ${response.status}`)
  }
  return await response.json()
}

const TopCommentAPIContextProvider: FunctionComponent<{
  children?: ReactNode
}> = ({ children }) => {
  const { articleId, commentsEnabled } = useContext(GenericCommentingContext)

  const { data: topCommentsData, error: topCommentsError } =
    useQuery<APICommentingData>(
      ['topCommentsData', articleId],
      () => getTopComments({ articleId }),
      {
        enabled: !!commentsEnabled,
      }
    )

  return (
    <TopCommentAPIContext.Provider
      value={{
        topComments: topCommentsError ? [] : topCommentsData?.content,
      }}>
      {children}
    </TopCommentAPIContext.Provider>
  )
}

export default TopCommentAPIContextProvider
